import React from "react";
import { useTranslation } from "react-i18next";
import PageTitle from "../../common/PageTitle";
import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import { ValType } from "../../utils/ValidationFunctions";
// css
import Styles from "./login.module.scss";
import { useMetaData } from "../../utils/useMetaData";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  isError: boolean;
  handleSubmit: () => void;
  handleEmail: (value: string) => void;
  handlePassword: (value: string) => void;
};

const LoginPage: React.FC<Props> = ({
  isError,
  handleSubmit,
  handleEmail,
  handlePassword,
}) => {
  const { t } = useTranslation();
  useMetaData({
    title: "ログイン",
    description:
      "SELeCTのアカウントをお持ちの方はこちらからログインください。eスポーツ活動をサポートするサービス「SELeCT」！スキルを活かしてeスポーツ・ゲームを仕事・就職・転職の選択肢にしたい方はぜひご利用ください。企業様のeスポーツ事業参入のサポート、イベント開催、スタッフ/アルバイトなどの求人募集、採用などもできます！",
    imgUrl: "",
  });
  return (
    <>
      <PageTitle title={"LOGIN"} />
      {/* <NoteNewsLink /> */}
      <div className={Styles["p-login__inner"]}>
        {isError ? (
          <div
            className={`${Styles["error-message"]} ${Styles["p-login-error-message"]}`}
          >
            {`入力したメールアドレス、またはパスワードが正しくないようです。`}
          </div>
        ) : null}
        <div className={Styles.main}>
          <div className={Styles["p-login__form-container"]}>
            <Form
              handler={handleSubmit}
              button_id="submitButton"
              button_text="ログイン"
              button_class={Styles.submit}
            >
              <div className={Styles.wrapper}>
                <FormInput
                  label="メールアドレス"
                  type="textBeforeLabel"
                  name="sonic_email"
                  val_type={ValType.NotNull}
                  placeholder="メールアドレス"
                  id="sonic_email"
                  handler={handleEmail}
                  style_class={Styles.form_input}
                  label_class={Styles.email_lb}
                />
              </div>
              <div className={Styles.wrapper}>
                <FormInput
                  label="パスワード"
                  type="login_password"
                  name="sonic_pass"
                  val_type={ValType.NotNull}
                  placeholder="パスワード"
                  id="sonic_pass"
                  handler={handlePassword}
                  style_class={Styles.form_input}
                  label_class={Styles.pass_lb}
                />
              </div>
            </Form>
          </div>
          <SonicLink to="/password-reminder" className={Styles["forget_link"]}>
            パスワードを忘れた方はこちら
          </SonicLink>
        </div>
        <div className={Styles["p-login__to-regist"]}>
          <div className={Styles["p-login__to-regist__text"]}>
            <span className={Styles["p-login__to-regist__text-inner"]}>
              {t("または")}
            </span>
          </div>
          <SonicLink
            className={Styles["p-login__to-regist__btn"]}
            to="/register"
          >
            {t("新規会員登録")}
          </SonicLink>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
